<script>
/**
 * This component can be used to render a $slot. $slot is passed as prop - view
 */
export default {
  name: 'RenderSlot',
  props: ['view'],
  render: function(createElement) {
    return createElement('div', this.view)
  }
}
</script>
